import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import {
  O2OPartnerUserAddInterface,
  O2OPartnerUserEditInterface,
  O2OPartnerUserListingInterface
} from "../interfaces/o2o-partner.interface";

@Injectable({ providedIn: "root" })
export class O2OPartnerUserService {
  private basePath: string = `${environment.url}/api/O2OPartnerUser`;

  constructor(private http: HttpClient) {}

  add(id: string, payload: O2OPartnerUserAddInterface) {
    return this.http.post(`${this.basePath}/Add/${id}`, payload);
  }

  getListing(
    id: string,
    limit: number,
    offset: number,
    text = "",
    columnIndex = 0,
    sortDirection = "desc"
  ) {
    return this.http.post<{
      count: number;
      data: O2OPartnerUserListingInterface[];
    }>(`${this.basePath}/GetListing/${id}`, {
      limit,
      offset,
      text,
      columnIndex,
      sortDirection
    });
  }

  update(id: string, payload: O2OPartnerUserEditInterface) {
    return this.http.post(`${this.basePath}/Update/${id}`, payload);
  }

  delete(id: string, userId: string) {
    return this.http.post(
      `${this.basePath}/Delete/${id}`,
      JSON.stringify(userId),
      {
        headers: { "Content-Type": "application/json" }
      }
    );
  }

  sendWelcomeEmail(id: string, userId: string) {
    return this.http.post(
      `${this.basePath}/SendWelcomeEmail/${id}`,
      JSON.stringify(userId),
      {
        headers: { "Content-Type": "application/json" }
      }
    );
  }
}
